import { createFileRoute } from "@tanstack/react-router";
import { Syndicates } from "@/components/Syndicates";

function RouteComponent() {
  return <Syndicates />;
}

export const Route = createFileRoute("/_authenticated/syndicates/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
